import { Orders } from "modules/orders";

const OrdersPage = () => {
  return <Orders />;
};

export default OrdersPage;
